export const MOBILE_APP_INVITE_LINK = "https://links.eyeball.club/product";
